import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  Table as TableUI,
  Typography,
} from '@astro-ui/components'
import { shallowEqual, useAppSelector } from 'store'
import { useMemo } from 'react'
import { dateFormat } from 'utils/helpers/date'
import SupplyOrderStatusChip from 'features/SupplyOrder/components/SupplyOrderStatusChip/SupplyOrderStatusChip'

const Table = () => {
  const data = useAppSelector((state) => state.outboundSODetail.data, shallowEqual)

  const list = useMemo(() => {
    if (!data) return []

    const information: (typeof data.supplyOrderActivities)[0]['activityLogList']['picking'] = []

    data.supplyOrderActivities.forEach((item) => {
      const { picking, packing, loading } = item.activityLogList || {}

      if (picking?.length) {
        information.push(...picking)
      }
      if (packing?.length) {
        information.push(...packing)
      }
      if (loading?.length) {
        information.push(...loading)
      }
    })

    return information
  }, [data])

  return (
    <Box>
      <TableUI
        tableContainerProps={{
          sx: { borderRadius: 0, boxShadow: 'unset', borderTop: '1px solid #E9E9E9' },
        }}
        tableHeaders={[]}
        TableHeaderComponent={
          <TableHead>
            <TableRow sx={{ backgroundColor: '#FAFAFA' }}>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  No
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Nama Aktivitas
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Tanggal Mulai
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Tanggal Selesai
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Durasi
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Oleh
                </Typography>
              </TableCell>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Status
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
        }
      >
        {list.map((item, index) => (
          <TableRow key={item.supplyOrderItemId}>
            <TableCell textAlign="center">{index + 1}</TableCell>
            <TableCell>
              <Typography>{item.activity}</Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {item.startAt
                  ? dateFormat({
                      date: new Date(item.startAt),
                      format: 'DD MMM YYYY - HH:mm:ss',
                    })
                  : '-'}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {item.endAt
                  ? dateFormat({
                      date: new Date(item.endAt),
                      format: 'DD MMM YYYY - HH:mm:ss',
                    })
                  : '-'}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>{item.duration || '-'}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{item.name}</Typography>
            </TableCell>
            <TableCell textAlign="center">
              <SupplyOrderStatusChip status={item.status} />
            </TableCell>
          </TableRow>
        ))}
      </TableUI>
    </Box>
  )
}

export default Table
